import { Grid, Toast } from "antd-mobile";
import React, { CSSProperties, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Group from "./Group";
import Item from "./Item";
import { getHdUser, wxsign } from "../../services/index";
import { WX_APPID } from "../../config";
import { isAndroid } from "../../utils/deviceUtils";
import storageUtil from "../../utils/storageUtil";
import { getQueryString } from "../../utils/httpUtil";

const wx = require("weixin-js-sdk");

const WorkplaceScreen: React.FC = React.memo(() => {
  const navigation = useNavigate();

  const [url, setUrl] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      setLoading(false);
      // 记录小程序跳转过来的url，因为后面进行微信jssdk签名需要用到
      storageUtil.setItem("INDEX_URL", window.location.href);
      const token = getQueryString("token");
      // 有token说明用户已经在小程序进行登录了，可以直接获取用户的手机号码获取我们系统token
      if (token && token !== "null") {
        storageUtil.setItem("MIN_PROGRAM_TOKEN", token);
        const signUrl = isAndroid()
          ? window.location.href
          : await storageUtil.getItem("INDEX_URL", false);
        setUrl(signUrl);
        // 获取当前小程序用户手机号码
        getHdUser(token)
          .then((data) => {
            if (data) {
              if (data.accessToken) {
                storageUtil.setItem("CREDENTIAL", data);
                setLoading(true);
              } else {
                Toast.show({
                  icon: "fail",
                  content: "抱歉，您无权限访问该应用。",
                  afterClose: () => {
                    wx.miniProgram.navigateBack();
                  },
                });
              }
            }
          })
          .catch((error) => {
            Toast.show({
              icon: "fail",
              content: "抱歉，您无权限访问该应用。",
              afterClose: () => {
                toLogin();
              },
            });
          });
      } else {
        // 没有小程序token，跳转到小程序进行登录
        toLogin();
      }
    };
    init();
  }, [navigation]);

  /**
   * 跳转小程序进行登录操作
   */
  const toLogin = () => {
    // 清空掉url中的token参数
    const url = window.location.href.replace("&token=null", "");
    const info = {
      faceScan: 1,
      legalSearch: 1,
      redirectType: 2,
      pathUrl: url,
    };
    let paramsInfo = encodeURIComponent(JSON.stringify(info));
    wx.miniProgram.redirectTo({
      url: `/pages/login/certLogin/index?info=${paramsInfo}`,
    });
  };

  useEffect(() => {
    //微信,通过config接口注入权限验证配置
    if (url) {
      wxsign(url)
        .then((data) => {
          if (data) {
            // 通过config接口注入权限验证配置
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: WX_APPID, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名
              jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
            });
            wx.error(function (e: any) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              // message.error("签名失败，请检查微信版本");
              Toast.show({
                content: "获取微信签名失败",
                afterClose: () => { },
              });
            });
          }
        })
        .catch((error) => {
          Toast.show({
            content: "获取微信签名失败",
            afterClose: () => { },
          });
        });
    }
  }, [url]);

  const inspect = () => {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res: any) {
        const result: string = res.resultStr;
        if (result.includes("?type=tree")) {
          const res = result.split("tree/");
          const id = res[1].split("?")[0];
          navigation(`/inspect/create/${id}`);
        } else {
          Toast.show({
            content: "无效的二维码，请扫描树木二维码",
            afterClose: () => { },
          });
        }
      },
    });
  };

  return (
    <div style={container}>
      {loading && (
        <Group title="树木管理">
          <Grid columns={4}>
            <Item
              label="树木建档"
              icon={require("./assets/1.png")}
              onPress={() => navigation("/tree/create")}
            ></Item>
            <Item
              label="一树一档"
              icon={require("./assets/1.png")}
              onPress={() => navigation("/tree/list")}
            ></Item>
            <Item
              label="巡查处理"
              icon={require("./assets/2.png")}
              onPress={inspect}
            ></Item>
            <Item
              label="巡查记录"
              icon={require("./assets/2.png")}
              onPress={() => navigation("/inspect/list")}
            ></Item>
          </Grid>
        </Group>
      )}
    </div>
  );
});

const container: CSSProperties = {
  flex: 1,
  backgroundColor: "#fff",
};

export default WorkplaceScreen;
